import { useCallback, useEffect, useState } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { getApiBaseUrl } from "../../config/apiBase"

const emptyCounts = { problems: 0, ideas: 0, refining: 0, actions: 0 }

export const useGroupWorkspaceCounts = (groupId, refreshKey = 0) => {
  const [counts, setCounts] = useState(emptyCounts)
  const { getAccessTokenSilently } = useAuth0()

  const refresh = useCallback(async () => {
    if (!groupId) return
    try {
      const token = await getAccessTokenSilently({
        authorizationParams: { audience: process.env.REACT_APP_API_AUDIENCE },
      })
      const response = await fetch(`${getApiBaseUrl()}/api/GroupsTbls/${groupId}/workspace-counts`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      if (!response.ok) throw new Error(`Counts request failed (${response.status})`)
      const data = await response.json()
      setCounts({
        problems: Number(data.needs || 0),
        ideas: Number(data.ideas || 0),
        refining: Number(data.refinements || 0),
        actions: Number(data.actions || 0),
      })
    } catch (error) {
      console.error("Unable to load workspace counts", error)
    }
  }, [getAccessTokenSilently, groupId])

  useEffect(() => { refresh() }, [refresh, refreshKey])
  return { counts, refresh }
}

export default useGroupWorkspaceCounts
